import type { Recording } from './types';
import type { RecordingDto, RecordingsForWidgetResponseDto } from './dto';

export const mapRecordingDtoToModel = ({
  id,
  country_code: countryCode,
  url,
  visitor_uuid: visitorUuid,
  action_count: actionCount,
  duration,
  relevance_score: relevanceScore,
  frustration_score: frustrationScore,
  created_epoch_time: created,
  rage_click_count: rageClickCount,
  u_turn_count: uTurnCount,
  page_count: pageCount,
  browser,
  device,
  landing_page_url: landingPageUrl,
  exit_page_url: exitPageUrl,
  is_first_seen: isFirstSeen,
  window_size: windowSize,
  watched,
}: RecordingDto): Recording => ({
  id,
  countryCode,
  url,
  duration,
  actionCount,
  visitorUuid,
  relevanceScore,
  frustrationScore,
  created,
  rageClickCount,
  uTurnCount,
  pageCount,
  browser,
  device,
  landingPageUrl,
  exitPageUrl,
  isFirstSeen,
  windowSize,
  watched,
});

export const mapRecordingsForWidgetResponseDtoToModel =
  function mapRecordingsForWidgetResponseDtoToModel(
    response: RecordingsForWidgetResponseDto,
  ): Recording[] {
    if (!response.recordings) return [];

    return response.recordings.map(mapRecordingDtoToModel);
  };
